import React from 'react';
import PropTypes from 'prop-types';
import styles from '../styles/LockItem.module.css';
import { formatGameDateTime } from '../utils/timeUtils';

const LockClosedIcon = () => (
  <svg className={styles.lockIcon} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24px" height="24px">
    <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"/>
  </svg>
);

const LockItem = ({ lock, ...props }) => {
  const formatLine = (line) => {
    if (line === undefined || line === null) return 'N/A';
    return line > 0 ? `+${line}` : line.toString();
  };

  // Handle bye week display
  if (lock.pickType === 'bye') {
    return (
      <div className={styles.lockItem}>
        <div className={styles.lockContent}>
          <div className={styles.lockedLabel}>Locked Pick</div>
          <div className={styles.primaryInfo}>
            <div className={styles.lockIconContainer}>
              <LockClosedIcon />
            </div>
            <span className={styles.pickDetails}>
              <span className={styles.team}>Bye</span>
              <span className={styles.byeWeek}>Week {lock.weekNumber}</span>
            </span>
          </div>
        </div>
      </div>
    );
  }

  // Regular pick display logic
  const getPickName = () => {
    if (lock.pickType === 'over' || lock.pickType === 'under') {
      return lock.pickType.charAt(0).toUpperCase() + lock.pickType.slice(1);
    }
    return lock.team || 'Unknown Team';
  };

  const { displayDate, displayTime } = formatGameDateTime(lock.startDate);

  return (
    <div className={styles.lockItem}>
      <div className={styles.lockContent}>
        <div className={styles.lockedLabel}>Locked Pick</div>
        <div className={styles.primaryInfo}>
          <div className={styles.lockIconContainer}>
            <LockClosedIcon />
          </div>
          <span className={styles.pickDetails}>
            <span className={styles.team}>{getPickName()}</span>
            <span className={styles.lockLine}>{formatLine(lock.lockLine)}</span>
          </span>
        </div>
        <div className={styles.gameInfo}>
          {`${lock.pickType === 'away' ? lock.team : lock.opponent} @
          ${lock.pickType === 'away' ? lock.opponent : lock.team}, ${displayDate}, ${displayTime}`}
        </div>
      </div>
    </div>
  );
};

LockItem.propTypes = {
  lock: PropTypes.shape({
    id: PropTypes.number.isRequired,
    team: PropTypes.string,
    opponent: PropTypes.string,
    pickType: PropTypes.string.isRequired,
    lockLine: PropTypes.number,
    gameDate: PropTypes.string,
    weekNumber: PropTypes.number,
    startDate: PropTypes.string,
  }).isRequired,
};

export default LockItem;
